"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateSingle = exports.validateMultiple = void 0;
const validateMultiple = (selectedDraw, quickDrawConfig) => {
    var _a, _b;
    if (!selectedDraw || !selectedDraw.resultData || selectedDraw.resultData.length === 0) {
        return false;
    }
    const defaultData = selectedDraw === null || selectedDraw === void 0 ? void 0 : selectedDraw.resultData;
    const hasWinningNumbers = !!defaultData && (defaultData === null || defaultData === void 0 ? void 0 : defaultData.length) > 0;
    const hasBullseye = !(!(quickDrawConfig === null || quickDrawConfig === void 0 ? void 0 : quickDrawConfig.bullseyeIndex) && (quickDrawConfig === null || quickDrawConfig === void 0 ? void 0 : quickDrawConfig.bullseyeIndex) !== 0) && hasWinningNumbers;
    if (hasBullseye) {
        const index = (_a = quickDrawConfig === null || quickDrawConfig === void 0 ? void 0 : quickDrawConfig.bullseyeIndex) !== null && _a !== void 0 ? _a : 0;
        const drawWinningNumbers = selectedDraw.resultData.map(r => r.data).slice(0, index);
        const drawBullsEye = selectedDraw.resultData[index].data;
        if (drawWinningNumbers.indexOf(drawBullsEye) === -1) {
            return false;
        }
    }
    const hasMultiplier = !(!(quickDrawConfig === null || quickDrawConfig === void 0 ? void 0 : quickDrawConfig.multiplierIndex) && (quickDrawConfig === null || quickDrawConfig === void 0 ? void 0 : quickDrawConfig.multiplierIndex) !== 0) && hasWinningNumbers;
    if (hasMultiplier) {
        const multiplier = hasMultiplier && !!defaultData && (defaultData === null || defaultData === void 0 ? void 0 : defaultData.length) > 0
            ? parseInt((_b = defaultData[(quickDrawConfig === null || quickDrawConfig === void 0 ? void 0 : quickDrawConfig.multiplierIndex) || 0]) === null || _b === void 0 ? void 0 : _b.data, 10)
            : 0;
        if ([1, 2, 3, 4, 5, 6, 10, 12, 20].indexOf(multiplier) === -1) {
            return false;
        }
    }
    return true;
};
exports.validateMultiple = validateMultiple;
const validateSingle = (selectedDraw) => {
    if (!selectedDraw || !selectedDraw.resultData || selectedDraw.resultData.length === 0) {
        return false;
    }
    const drawWinningNumber = parseInt(selectedDraw.resultData[0].data, 10);
    const drawWinningPrize = selectedDraw.cashAmount;
    if (!drawWinningNumber || !drawWinningPrize) {
        return false;
    }
    if (drawWinningNumber < 1 || drawWinningNumber > 15) {
        return false;
    }
    return [20, 50, 100, 250, 5, 7, 10].indexOf(drawWinningPrize) !== -1;
};
exports.validateSingle = validateSingle;
//# sourceMappingURL=validation-utils.js.map